import Agency from '../views/agency/Agency.vue'
import BadReferencesTable from '../views/wallet/BadReferencesTable.vue'

import layouts from '../layout'

export default {
	path: '/wallet',
    name: 'wallet',
    component: Agency,
	meta: {
		auth: true,
		layout: layouts.navLeft
	},
	children: [
		{
			path: 'bad-references',
			name: 'bad-references-list',
			component: BadReferencesTable,
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				title: 'Agency List',
				tags: ['agency']
			}
		}
	]
}



// WEBPACK FOOTER //
// ./src/router/wallet.js